import Component from './PendingPaymentsTable';

export default Component;
